import { get } from 'lodash'
import { required, email } from 'utils/validation'
import { CONFIGURATION_KEYS } from '../../constants/enums'

export default function(values = {}, props) {

  const cfg = get(props, 'configuration')

  const orgId = get(props, 'activeOrganizationId')

  const isConfigTrue = configKey => get(cfg, `valuesByOrganizationId[${orgId}][${configKey}].booleanValue`)

  return {
    person: {
      email: email(get(values, 'person.email')),
      secondaryEmail: email(get(values, 'person.secondaryEmail')),
      address: {
        country: {
          id: isConfigTrue(CONFIGURATION_KEYS.awardStaffRegistrationAddressCountry.id) && required(get(values, 'person.address.country.id'))
        }
      }
    }
  }
}
